const variantPriorityOrder = [
    "animate" /* AnimationType.Animate */,
    "whileInView" /* AnimationType.InView */,
    "whileFocus" /* AnimationType.Focus */,
    "whileHover" /* AnimationType.Hover */,
    "whileTap" /* AnimationType.Tap */,
    "whileDrag" /* AnimationType.Drag */,
    "exit" /* AnimationType.Exit */,
];
const variantProps = ["initial", ...variantPriorityOrder];

export { variantPriorityOrder, variantProps };
